// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Layout__-loca-__6RipO","Layout":"Layout__-loca-__3GPqm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/Layout.css
// module id = 184
// module chunks = 0